import React from 'react';

const EditIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M13.367 7.23l-9.133 9.134H1.636v-2.598l9.133-9.133 2.598 2.598zm1.157-1.156l1.133-1.133a1 1 0 000-1.414l-1.184-1.184a1 1 0 00-1.414 0l-1.132 1.133 2.597 2.598z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default EditIcon;
